<div [class]="this.class" >
    <img [class]="this.imageClass" [src]='this.titleIcon' />
    <h3 class="amount">{{content}}</h3>
    <p class="subtitle">{{subtitle}}</p>
</div>
